import React, { useState } from 'react';
import PaywallModal from '../components/UnifiedModal/variants/PaywallModal';

/**
 * PaywallModalDemo
 *
 * Dev-only route (/paywall-demo) that renders both variants of PaywallModal
 * so we can screenshot the bot-limit fix without having to set up real DB
 * state (a Starter-plan user at the 1-bot limit).
 *
 * Not linked from anywhere in the app. Reach it directly via the URL.
 */
export default function PaywallModalDemo() {
  const [showBotLimit, setShowBotLimit] = useState(true);
  const [showGeneric, setShowGeneric] = useState(false);

  return (
    <div style={{ padding: 40, maxWidth: 700, margin: '0 auto', color: '#fff' }}>
      <h1>Paywall Modal Demo</h1>
      <p>Dev-only route for screenshotting modal states.</p>

      <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
        <button
          onClick={() => { setShowBotLimit(true); setShowGeneric(false); }}
          style={{ padding: '10px 20px', borderRadius: 6, border: 'none', cursor: 'pointer', background: '#10a37f', color: '#fff' }}
        >
          Show bot-limit variant (paid user at limit)
        </button>
        <button
          onClick={() => { setShowGeneric(true); setShowBotLimit(false); }}
          style={{ padding: '10px 20px', borderRadius: 6, border: 'none', cursor: 'pointer', background: '#555', color: '#fff' }}
        >
          Show generic paywall (free-tier user)
        </button>
      </div>

      <PaywallModal
        isOpen={showBotLimit}
        onClose={() => setShowBotLimit(false)}
        limitType="bot"
        usage={{ used: 1, limit: 1, remaining: 0 }}
        activeDeployments={[
          {
            deployId: 'demo-deploy-1',
            botId: 'demo-bot-1',
            botName: 'Volatility Breakout ATR',
            strategyId: 'demo-strat-1',
            strategyName: 'Volatility Breakout ATR'
          }
        ]}
      />

      <PaywallModal
        isOpen={showGeneric}
        onClose={() => setShowGeneric(false)}
        limitType="bot"
        usage={{ used: 0, limit: 0, remaining: 0 }}
        activeDeployments={[]}
      />
    </div>
  );
}
